import { Component, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { ReproductionsTableService } from 'src/app/modules/acbcr/common/services/reproductions-table.service';

@Component({
  selector: 'app-reproductie-monta-naturala',
  templateUrl: './reproductie-monta-naturala.component.html',
  styleUrls: ['./reproductie-monta-naturala.component.scss']
})
export class ReproductieMontaNaturalaComponent {
  @Input() monta;
  @Input() form: UntypedFormGroup;
  @Input() field_errors;

  isSuperAdmin = false;
  isAdmin = false;
  isFermier = false;
  exploatatieID;
  autorizatiiMonta = [];
  listaFemele = [];
  listaTauri = [];
  taurErrors = [];
  taurWarnings = [];
  disabledFields = {};
  listaFemeleSelectate = []

  constructor(
    private helperDataService: HelperDataService,
    private reproductionsTableService: ReproductionsTableService,
  ) { }

  ngOnInit(): void {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isFermier = UIHelper.isFermier();
  }

  ngOnChanges(changes) {
    if (changes.monta) {
      this.buildForm(this.monta);
    }
  }

  buildForm(formData?) {
    if (!formData) {
      formData = {};
    }

    this.form.addControl('data_start_monta', new UntypedFormControl(formData['data_start_monta']));
    this.form.addControl('data_final_monta', new UntypedFormControl(formData['data_final_monta']));
    this.form.addControl('taur_id', new UntypedFormControl(formData['taur_id']));
    this.form.addControl('rasa_id', new UntypedFormControl(formData['rasa_id']));
    this.form.addControl('autorizatie_id', new UntypedFormControl(formData['autorizatie_id']));
    this.form.addControl('femele_ids', new UntypedFormControl(formData['femele_ids']));

    this.exploatatieID = this.form.value.exploatatie_id || formData['exploatatie_id'];
    this.listaFemele = formData['lista_femele'] || [];
    this.listaTauri = formData['lista_tauri'] || [];
    this.autorizatiiMonta = formData['autorizatii_monta'] || [];
    this.disabledFields = formData['disabled_fields'] || {};
    this.field_errors = {};
    this.updateFemele();
  }

  dataMontaChange(event) {
    this.form.controls.data_start_monta.setValue(event);
    this.field_errors['data_start_monta'] = null;
    this.getListaTauri();
    this.getAutorizatiiTaur();
    this.getListaFemele();
  }

  dataEndMontaChange(event) {
    this.form.controls.data_final_monta.setValue(event);
    this.field_errors['data_final_monta'] = null;
    this.getAutorizatiiTaur();
  }

  selectTaur(event) {
    let taurID = event ? event['id'] : null;
    let rasaID = event ? event['rasa_id'] : null;
    this.form.controls.taur_id.setValue(taurID);
    this.form.controls.rasa_id.setValue(rasaID);
    this.taurErrors = [];
    this.taurWarnings = [];

    if (taurID) {
      this.field_errors['taur_id'] = null;
    }

    if (!event) {
      this.getListaTauri();
    }

    this.getAutorizatiiTaur();
    this.getListaFemele();
  }

  getAutorizatiiTaur() {
    const taurID = this.form.value.taur_id;
    const dataStart = this.form.value.data_start_monta;
    const dataFinal = this.form.value.data_final_monta;
    this.autorizatiiMonta = [];
    this.taurErrors = [];
    this.taurWarnings = [];
    this.form.controls.autorizatie_id.setValue(null);
    this.field_errors['autorizatie_id'] = null;

    if (!taurID || !dataStart || !dataFinal) {
      return;
    }

    let req_params = {
      id: taurID,
      data_start_monta: dataStart,
      data_final_monta: dataFinal,
    };

    this.reproductionsTableService.getAutorizatii(req_params)
      .subscribe({
        next: (response) => {
          if (!response) {
            return;
          }

          this.taurErrors = response['errors'];
          this.taurWarnings = response['warnings'];
          this.autorizatiiMonta = response['autorizatii_monta'];

          if (this.autorizatiiMonta && this.autorizatiiMonta.length === 1) {
            let autorizatieId = this.autorizatiiMonta[0]['id'];
            this.form.controls.autorizatie_id.setValue(autorizatieId);
          }
        }
      });
  }

  selectFemela(element, event) {
    this.field_errors['femele_ids'] = null;
    const femelaID = event ? event['id'] : null;

    if (femelaID) {
      let femeleIDs = this.form.value.femele_ids || [];
      femeleIDs.push(femelaID);
      this.form.controls.femele_ids.setValue(femeleIDs);
    }

    if (element && element.hasValue) {
      element.clearModel();
    }

    this.updateFemele();
  }

  deleteFemela(index) {
    let femeleIDs = this.form.value.femele_ids || [];
    femeleIDs.splice(index, 1);
    this.form.controls.femele_ids.setValue(femeleIDs);
    this.updateFemele();
  }

  updateFemele() {
    let femeleIDs = this.form.value.femele_ids || [];
    this.listaFemeleSelectate = [];

    femeleIDs = femeleIDs.filter(
      (femID) => {
        const femela = this.listaFemele.find(
          (item) => item['id'] === femID
        );

        if (femela) {
          this.listaFemeleSelectate.push(femela);
          return true;
        } else {
          return false;
        }
      }
    );

    this.listaFemele = this.listaFemele.map(
      (item) => {
        if (femeleIDs.includes(item['id'])) {
          item['disabled'] = true;
        } else {
          item['disabled'] = false;
        }

        return item;
      }
    );

    this.form.controls.femele_ids.setValue(femeleIDs);
  }

  getListaFemele() {
    this.listaFemele = [];
    const dataStart = this.form.value.data_start_monta;
    const rasaID = this.form.value.rasa_id;

    if (!this.exploatatieID || !rasaID || !dataStart) {
      return;
    }

    let req_params = {
      exploatatie_id: this.exploatatieID,
      rasa_id: this.form.value.rasa_id,
      data: dataStart,
    };

    this.reproductionsTableService.getVaci(req_params)
      .subscribe((response: Array<any>) => {
        this.listaFemele = response || [];
        this.updateFemele();
      });
  }

  getListaTauri() {
    this.listaTauri = [];

    if (!this.exploatatieID || !this.form.value.data_start_monta) {
      return;
    }

    let req_params = {
      exploatatie_id: this.exploatatieID,
      data_start_monta: this.form.value.data_start_monta,
    };

    this.reproductionsTableService.getTauriMN(req_params)
      .subscribe((response: Array<any>) => {
        this.listaTauri = response || [];

        let taurGasit = this.listaTauri.find(
          (item) => item['id'] === this.form.value.taur_id
        );

        if (!taurGasit) {
          this.form.controls.taur_id.reset();
          this.getAutorizatiiTaur();
        }
      });
  }

  selectAutorizatie(event, autorizatieId) {
    this.form.controls.autorizatie_id.setValue(autorizatieId);
    event.target.checked = true;
  }

  downloadAutorizatieFile(autorizatie) {
    const fileId = autorizatie['file_id'];
    const fileName = autorizatie['file_name'];

    if (!fileId) {
      return;
    }

    this.helperDataService.downloadFile(fileId)
      .subscribe((response: any) => {
        const blob = new Blob([response]);
        this.helperDataService.simulateDownload(blob, fileName);
      });
  }
}
